
import Button from '../../../components/base/Button';

export default function ProfileSection() {
  return (
    <section id="profile" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">プロフィール</h2>
          <div className="w-24 h-1 bg-pink-200 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="mb-8">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                SBSラジオキャスタードライバーを経て、フリーに転身。ラジオパーソナリティやリポーター、イベントMCなどを務める。また舞台作品制作事業「ラウドヒル計画」に参加し、舞台女優の一面も!? 現在、一児の母として子育てに奮闘中! ご依頼いただいたお仕事は誠心誠意、精一杯務めさせていただきます!
              </p>
            </div>

            <div className="space-y-6">
              <div className="border-b border-gray-200 pb-4">
                <div className="flex justify-between items-center">
                  <h3 className="font-semibold text-gray-800">出身地</h3>
                  <p className="text-gray-600">静岡市</p>
                </div>
              </div>

              <div className="border-b border-gray-200 pb-4">
                <div className="flex justify-between items-center">
                  <h3 className="font-semibold text-gray-800">学歴</h3>
                  <p className="text-gray-600">フェリス女学院大学音楽学部卒業</p>
                </div>
              </div>

              <div className="border-b border-gray-200 pb-4">
                <div className="flex justify-between items-center">
                  <h3 className="font-semibold text-gray-800">誕生日</h3>
                  <p className="text-gray-600">1992年7月7日</p>
                </div>
              </div>

              <div className="border-b border-gray-200 pb-4">
                <h3 className="font-semibold text-gray-800 mb-3">現在の出演</h3>
                <div className="space-y-3 text-gray-600">
                  <div className="text-red-600 font-medium">
                    <p>RADIO LUSH (YAIZU FM)</p>
                    <p>「エムスタ!」毎週木曜 11:00~13:00</p>
                  </div>
                </div>
              </div>

              <div className="border-b border-gray-200 pb-4">
                <h3 className="font-semibold text-gray-800 mb-3">趣味・特技</h3>
                <div className="text-gray-600 space-y-1">
                  <p>・舞台鑑賞</p>
                  <p>・エレクトーン</p>
                  <p>・御朱印集め</p>
                  <p>・ご当地キティグッズ集め</p>
                  <p>・ダンス</p>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <img 
              src="https://shabell.jp/images/saoriandou.jpg"
              alt="安藤紗織プロフィール写真"
              className="w-full max-w-md mx-auto rounded-lg shadow-lg object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}